import axios from 'axios';

export default class ResponsabilidadEntregaService {

    getResponsabilidadEntrega() {            
        const url = process.env.VUE_APP_APIURL + `/api/responsabilidadentrega`;    
        return axios.get(url).then(res=>res.data);
    }
 
}